import React from 'react';
import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import { InputLabel, FormControl, Select, OutlinedInput } from '@material-ui/core';
import styles from './commonYesNo.module.css';

const PADDING: string = '6px 12px';

const stylesMaterial = (theme: Theme) =>
  createStyles({
    matchingPhoto: {
      color: 'var(--primaryblue)',
      fontSize:'13px'
    },
    grey: {
      transform: 'translate(14px, 14px) scale(1)',
      color: 'rgb(0,0,0,0.26)',
      fontSize: '14px'
    },
    blue: {
      transform: 'translate(14px, 14px) scale(1)',
      color: 'var(--primaryblue)',
      fontSize: '13px'
    },
    w100: {
      width: '100%'
    }
  });

interface CommonYesNoProps {
  classes: any;
  label: string;
  name: string;
  options: Array<string>;
  index: number;
  handleChange: Function;
  editable: boolean;
  disabled: boolean;
};

const CommonYesNo = (props: CommonYesNoProps) => {
  const inputLabel: boolean = props.label === 'Matching Photo?' ? true: false;
  const inputLabelStyle: string =  props.options[props.index] === '' ? props.classes.grey : props.classes.blue ;
  const labelWidth: number = props.label === 'Matching Photo?' ? 120 : 0

  return (
    <div className = { styles.fieldWrapper }>
       { !inputLabel && <InputLabel htmlFor={props.name} className={ props.classes.matchingPhoto } >{ props.label }</InputLabel> }
      <FormControl variant="outlined" className={ props.classes.w100 }>
        { inputLabel &&
          <InputLabel htmlFor={props.name} className={ inputLabelStyle } >{ props.label }</InputLabel >
        }
        <Select native
          disabled={ !props.editable || !props.disabled }
          className={ props.classes.select }
          onChange={ (event) => props.handleChange(event) }
          value={ props.options[props.index] }
          inputProps={ { name: props.name, id: props.name, style: { padding: PADDING ,maxWidth:'190px' } } }
          input={ <OutlinedInput labelWidth={ labelWidth }  /> }
        >
          {
            props.options.map((option: string, index: number) => (
              <option key={ index } value={ option }>{ option }</option>
            ))
          }
        </Select>
      
      </FormControl>
    </div>
  );
};
export default withStyles(stylesMaterial)(CommonYesNo);